// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:00:34

export default {
  "id": "sweetsu-tile-puzzle",
  "slug": "sweetsu-tile-puzzle",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/37f6605c62e64e6c89df9244efc42ef2-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/37f6605c62e64e6c89df9244efc42ef2/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Sweetsu Tile Puzzle",
      "description": "Sweet Tile Puzzle is a relaxing yet strategic game. Match 3 identical Japanese-themed tiles by drawing them into a limited stack. Clear the board by collecting all tiles while managing space wisely. With each level, challenges grow as the stack shrinks and more tiles appear. Can you master the art of tile matching?",
      "instructions": "Use a mouse or touchpad to play this game.",
      "genres": [
        "Match-3"
      ],
      "tags": [
        "block",
        "candy",
        "girls",
        "matching",
        "tiles"
      ]
    },
    "zh-CN": {
      "title": "甜蜜苏拼图",
      "description": "甜蜜拼图游戏是一款轻松而富有策略的游戏。通过拖动相同主题的日式瓷砖进行匹配，每次最多只能匹配3个。通过巧妙管理空间，收集所有瓷砖来清除棋盘。随着每一关的进行，挑战不断增加，因为堆叠的瓷砖数量减少，出现的瓷砖种类也增多。你能掌握瓷砖匹配的艺术吗？",
      "instructions": "使用鼠标或触摸板来玩这款游戏。",
      "genres": [
        "三消匹配"
      ],
      "tags": [
        "方块",
        "糖果",
        "女孩",
        "匹配",
        "瓷砖"
      ]
    },
    "zh-TW": {
      "title": "甜須拼圖瓷砖",
      "description": "甜心拼圖遊戲是一款舒適卻需要策略的遊戲。通過畫取有限堆積中的3個相同的日本主題磚塊來匹配它們。通過智慧地管理空間，收集所有磚塊來清空遊戲版面。隨著每一關的進行，挑戰隨著堆積的縮小和更多磚塊的出現而增加。你能否精通磚塊匹配的藝術？",
      "instructions": "使用滑鼠或觸控板來玩這款遊戲。",
      "genres": [
        "對決3子"
      ],
      "tags": [
        "方塊",
        "糖果",
        "少女",
        "匹配",
        "磚塊"
      ]
    },
    "zh-HK": {
      "title": "甜蜜頓拼圖",
      "description": "甜蜜拼圖遊戲是一款舒緩而策略性的遊戲。透過拖動匹配3個相同的日式主題拼圖來滿足限制堆疊。透過智慧地管理空間，收集所有拼圖來清空遊戲版面。隨著每個關卡，挑戰隨著堆疊縮小及更多拼圖出現而增加。你能掌握拼圖匹配的藝術嗎？",
      "instructions": "使用滑鼠或觸控板來玩這款遊戲。",
      "genres": [
        "配對3"
      ],
      "tags": [
        "阻塊",
        "糖果",
        "少女",
        "配對",
        "圖片"
      ]
    },
    "ja": {
      "title": "スイーツタイルパズル",
      "description": "スイート・タイル・パズルは、リラックスしつつ戦略的なゲームです。限られたスタックにタイルを引き寄せて3つ以上の同一の日本風のタイルをマッチさせ、ボードをクリアします。全てのタイルを収集しながら、スペースを賢く管理することでクリアを目指します。レベルごとに、スタックが狭くなり、さらにタイルが増えることで挑戦が高まります。タイルマッチングの技量をマスターできるでしょうか？",
      "instructions": "マウスまたはタッチパッドを使用してこのゲームをプレイしてください。",
      "genres": [
        "マッチ3"
      ],
      "tags": [
        "ブロック",
        "キャンディ",
        "ガールズ",
        "マッチング",
        "タイル"
      ]
    },
    "ko": {
      "title": "스위츠 타일 퍼즐",
      "description": "스위트 타일 퍼즐은 쉬운 마음을 가지면서도 전략적인 게임입니다. 제한된 스택에 타일을 맞추어 3개 이상의 일치하는 일본 테마 타일을 맞춥니다. 전략적으로 공간을 관리하여 모든 타일을 수집하여 보드를 클리어하세요. 각 레벨마다 스택이 줄어들고 더 많은 타일이 등장하면서 도전이 증가합니다. 타일 매칭의 기술을 마스터할 수 있을까요?",
      "instructions": "이 게임을 플레이하려면 마우스나 터치패드를 사용하세요.",
      "genres": [
        "매치3"
      ],
      "tags": [
        "블록",
        "캔디",
        "소녀",
        "매칭",
        "타일"
      ]
    },
    "fr": {
      "title": "Sweetsu Puzzle en Carré",
      "description": "Sweet Tile Puzzle est un jeu apaisant mais stratégique. Association de 3 tuiles japonaises identiques en les tirant dans une pile limitée. Nettoyez le plateau en collectant toutes les tuiles tout en gérant l'espace intelligemment. À chaque niveau, les défis augmentent alors que la pile se rétrécit et que plus de tuiles apparaissent. Pouvez-vous maîtriser l'art de l'association de tuiles ?",
      "instructions": "Utilisez une souris ou un pavé tactile pour jouer à ce jeu.",
      "genres": [
        "Jeu de correspondance 3-3"
      ],
      "tags": [
        "bloc",
        "bonbon",
        "filles",
        "correspondance",
        "tuiles"
      ]
    }
  }
};
